import request from '@/http/request'
export const getTokenByCode = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/api/login`, params)
}
